import React from "react";
import "./footer.css";
const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="footer-btn">
          <a href="mailto:abhijithpillai174@gmail.com">
            <button className="btn">Get In Touch</button>
          </a>
        </div>
        <p className="footer-content">
          Designed and Built by <span>Abhijith Pillai</span>
        </p>
      </div>
    </>
  );
};

export default Footer;
